<template>
  <div class="small">
    <line-chart :chartdata="chartdata" :options="options" :style="style"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import LineChart from "./LineChart";

export default {
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: this.healthAge + 10,
                suggestedMin: this.healthAge - 10,
                stepSize: 5
              }
            }
          ]
        }
      },
      style: {
        height: '150px',
        width: '100%',
        position: 'relative'
      }
    };
  },
  props: {
    label: VueTypes.arrayOf(VueTypes.string.isRequired),
    realAge: VueTypes.number.isRequired,
    healthAge: VueTypes.number.isRequired
  },
  components: {
    LineChart
  },
  computed: {
    chartdata() {
      return {
        // labels use for test only
        labels: ["2019", "2020", "2021", "2022"],
        datasets: [
          {
            label: this.$t('aiPredictionReport.actualAge'),
            data: [this.realAge],
            borderColor: "#95BE91",
            backgroundColor: "rgba(0, 0, 0, 0)"
          },
          {
            label: this.$t('aiPredictionReport.healthAge'),
            data: [this.healthAge],
            borderColor: "#45A0DA",
            backgroundColor: "rgba(0, 0, 0, 0)"
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
</style>
